import { useLocalStorage } from "@src/appV2/lib/utils";

import { AuthMode } from "../libs";

export function useDefaultAuthScreen() {
  const [defaultToLoginPage, setDefaultToLoginPage] = useLocalStorage<boolean>(
    "defaultToLoginPage",
    false
  );

  const defaultAuthMode = defaultToLoginPage ? AuthMode.LOGIN : AuthMode.SIGN_UP;

  return {
    defaultAuthMode,
    setDefaultToLogin: setDefaultToLoginPage,
  };
}
